// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file questionnaire/v1/template_service.proto (package questionnaire.v1, syntax proto3)
/* eslint-disable */

import { TemplateService } from "./template_service_pb";

/**
 * @generated from rpc questionnaire.v1.TemplateService.Import
 */
export const import$ = TemplateService.method.import;

/**
 * @generated from rpc questionnaire.v1.TemplateService.ListTemplates
 */
export const listTemplates = TemplateService.method.listTemplates;

/**
 * @generated from rpc questionnaire.v1.TemplateService.GetTemplate
 */
export const getTemplate = TemplateService.method.getTemplate;

/**
 * @generated from rpc questionnaire.v1.TemplateService.DeleteTemplate
 */
export const deleteTemplate = TemplateService.method.deleteTemplate;

/**
 * @generated from rpc questionnaire.v1.TemplateService.ListTemplateQuestion
 */
export const listTemplateQuestion = TemplateService.method.listTemplateQuestion;

/**
 * @generated from rpc questionnaire.v1.TemplateService.UpdateTemplate
 */
export const updateTemplate = TemplateService.method.updateTemplate;

/**
 * @generated from rpc questionnaire.v1.TemplateService.RenameSection
 */
export const renameSection = TemplateService.method.renameSection;

/**
 * @generated from rpc questionnaire.v1.TemplateService.UpdateQuestion
 */
export const updateQuestion = TemplateService.method.updateQuestion;

/**
 * @generated from rpc questionnaire.v1.TemplateService.DeleteQuestion
 */
export const deleteQuestion = TemplateService.method.deleteQuestion;

/**
 * @generated from rpc questionnaire.v1.TemplateService.AddQuestion
 */
export const addQuestion = TemplateService.method.addQuestion;

/**
 * @generated from rpc questionnaire.v1.TemplateService.UpdateOption
 */
export const updateOption = TemplateService.method.updateOption;

/**
 * @generated from rpc questionnaire.v1.TemplateService.CreateBlankTemplate
 */
export const createBlankTemplate = TemplateService.method.createBlankTemplate;
